import { FC, useContext, useEffect, useState } from 'react'
import { FieldValues, useForm } from 'react-hook-form'
import { Link, useNavigate } from 'react-router-dom'
import Button from '../../components/Button/Button'
import { logIn } from '../../services/auth/service'
import { getCurrentUser } from '../../services/api/me'
import { TibiContext } from '../../context/ContextProvider'
import AuthLayout from '../../components/AuthLayout/AuthLayout'
import DynamicFaIcon from '../../components/DynamicFaIcon/DynamicFaIcon'

interface LoginProps {}

const Login: FC<LoginProps> = () => {
    const navigate = useNavigate()
    const [error, setError] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)
    const {
        register,
        formState: { isValid },
        handleSubmit
    } = useForm()
    const { setValue } = useContext(TibiContext)

    useEffect(() => {
        //Check if user is already logged in
    }, [])

    const onSignIn = async (data: FieldValues) => {
        setLoading(true)
        setError('')
        try {
            // Login first
            const result = await logIn({ username: data.email, password: data.password })

            // Get userdata after login
            const { data: userData } = await getCurrentUser()

            // dispatch userData to context
            if (userData) {
                setValue({ user: userData })
            }

            if (result) {
                navigate('/dashboard')
            }
        } catch (e: any) {
            setError(e.message)
        }
        setLoading(false)
    }

    return (
        <AuthLayout>
            <div className='rounded-xl bg-white border p-10 text-left text-[--tb-text] max-w-[600px] w-full shadow-lg relative z-20'>
                <h3 className='text-3xl text-center mb-8'>Welkom terug</h3>
                <form onSubmit={handleSubmit(onSignIn)} className='flex flex-col space-y-4'>
                    <span className='font-semibold'>Login</span>
                    <input
                        {...register('email', { required: true })}
                        disabled={loading}
                        className='border border-gray-200 rounded-md'
                        placeholder='E-mail'
                        type='text'
                        autoComplete='username'
                    />
                    <input
                        {...register('password', { required: true })}
                        className='border border-gray-200 rounded-md'
                        disabled={loading}
                        placeholder='Password'
                        type='password'
                        autoComplete='current-password'
                    />
                    <Link to='/reset-password' className='text-[--tb-text] text-sm text-right'>
                        Problemen met inloggen?
                    </Link>
                    <Button type='submit' disabled={!isValid || loading}>
                        {loading ? (
                            <>
                                <DynamicFaIcon iconName='spinner' className='mr-2' spin />
                                Logging in..
                            </>
                        ) : (
                            <span>Log in</span>
                        )}
                    </Button>
                    {error && <p className='text-red-700 mt-3 text-sm'>{error}</p>}
                </form>
            </div>
        </AuthLayout>
    )
}

export default Login
